import { useState } from 'react';
import { ListGroup } from 'react-bootstrap';

import ButtonType from './ButtonType';
import LoadingWrapper from './LoadingWrapper';
import TextArea from './TextArea';

import { infoToast } from '../components/Toasty';

import TaskService from '../services/TaskService';

import EmployeeInfo from '../types/Employee/EmployeeInfo';
import ITaskComment from '../types/Task/TaskComment';

type Props = {
    userData: EmployeeInfo;
    taskID: number;
    preloadedComments: ITaskComment[];
    addEvent: (e: any) => void;
    readonly?: boolean;
    isMocked: boolean;
};

export default function TaskDiscussion({
    userData,
    taskID,
    preloadedComments,
    addEvent,
    readonly,
    isMocked,
}: Props) {
    const [comments, setComments] = useState<ITaskComment[]>(preloadedComments);
    const [newComment, setNewComment] = useState('');
    const [pendingAdd, setPendingAdd] = useState(false);

    const inputHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setNewComment(event.target.value);
    };

    const handleAddComment = () => {
        if (isMocked) {
            const msg = 'You have clicked on the "Save" button.  This has been disabled because you are currently not yourself.';
            infoToast(msg);
            return;
        }

        const userEmail = userData.email;
        const userName = userData.employeeName;

        setPendingAdd(true);

        const comment: ITaskComment = {
            id: taskID,
            comment: newComment,
            user: userEmail,
            date: new Date().toISOString(),
        };

        TaskService.addComment(comment)
            .then(() => {
                comment.user = userName;
                const updatedComments = [comment, ...comments];
                setPendingAdd(false);
                setNewComment('');
                setComments(updatedComments);
                addEvent(updatedComments);
            })
            .catch(() => {
                setPendingAdd(false);
            });
    };

    return (
        <div>
            <TextArea
                key={comments.length}
                dataName="newComment"
                title="Comments"
                rows={3}
                value={newComment}
                onchange={inputHandler}
                readonly={readonly || pendingAdd}
            />
            <ButtonType
                dataName="addComment"
                buttonText="Save"
                type="button"
                eventHandler={handleAddComment}
                readOnly={newComment.length === 0 || pendingAdd}
            />
            <hr />
            <LoadingWrapper showLoading={pendingAdd}>
                <ListGroup>
                    {comments.map((comment, i) => {
                        const commentDate = new Date(comment.date);
                        return (
                            <ListGroup.Item key={i}>
                                <p className="mb-1 commentListItem">{comment.comment}</p>
                                <div className="d-flex">
                                    <small>- {comment.user}</small>
                                </div>
                                <div className="d-flex">
                                    <small>
                                        {commentDate.toLocaleString('en-US', {
                                            month: 'short',
                                            day: 'numeric',
                                            year: 'numeric',
                                            hour: 'numeric',
                                            minute: 'numeric',
                                            hour12: true,
                                            timeZoneName: 'short',
                                        })}
                                    </small>
                                </div>
                            </ListGroup.Item>
                        );
                    })}
                </ListGroup>
            </LoadingWrapper>
        </div>
    );
}